/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import Hex from 'solis/type/hex';
import HexGroup from 'solis/type/hex/group';

import BoardCass from 'solis/logic/board/cass';
import BoardFrontierType from 'solis/logic/board/frontier.type';
import BoardProximity from 'solis/logic/board/proximity';
import ColonyCass from 'solis/logic/board/colony/cass';


const isEmptyTransform = (transform) =>
{
  return transform.offset.equals(new Hex(0, 0)) && transform.rotation === 0;
};


export default class BoardScore extends Logic
{
  transferRewardToFounderColony ()
  {
    const sector = new ColonyCass(this.getFounderColony()).getCoreSector();

    sector.set({ currency: sector.cass.currency + new BoardCass(this.object).getCurrencyReward() });
  }


  calculateAuthority (date)
  {
    const proximity = new BoardProximity(this.object, BoardFrontierType.Zone);

    for (const zone of this.object.getZones().values())
    {
      const closestID = proximity.getClosestColony(new HexGroup([ zone.getAbsoluteHex() ]));

      if (closestID === null)
      {
        continue;
      }

      const colony = this.object.getColony(closestID);

      const fraction = new ColonyCass(colony).getScoreFraction(date);

      colony.set({ authority: colony.cass.authority + this.getZoneAuthority(zone) * fraction });
    }
  }


  getZonesByAuthority ()
  {
    const entries = this.object.getZones().values().map(zone => ({ zone, authority: this.getZoneAuthority(zone) }));

    return entries.sort((lhs, rhs) => rhs.authority - lhs.authority);
  }


  getZoneAuthority (zone)
  {
    let authority = zone.cass.value;

    for (const hex of zone.getAbsoluteHex().getNeighbors())
    {
      const neighbor = this.object.getZone(hex);

      if (neighbor !== null)
      {
        authority += Math.max(0, zone.cass.value - neighbor.cass.value);
      }
    }

    return authority;
  }


  getFounderColony ()
  {
    for (const colony of this.object.getColonies().values())
    {
      if (isEmptyTransform(colony.cass.transform))
      {
        return colony;
      }
    }

    return null;
  }


};
